/***
 * sdk索引文件,配置需要加载的包
 */
// es6 兼容
import "core-js/stable";
import "regenerator-runtime/runtime";
//
const VERSION = require('./version');
const Map = require('./map/Map');
const base = require('./base/index');
const layers = require('./layers/index');
const plot = require('./plot/index');
const utils = require('./utils/index');
const serviceV3 = require('./service/emap/v3/index');
const serviceV2 = require('./service/emap/v2/index');
const data = require('./data/index');
//
const misc = require('./misc/index');
const components = require('./components/index');
//
const common = require('./common/index');
const interact = require('./interact/index');
const render = require('./render/index');
const model = require('./model/index');
const business = require('./business/index');
/**
 * 应急一张图
 * @namespace G
 */
const _exports = {};
//3.0延续
_exports.Map = Map;
_exports.base = base;
_exports.plot = plot;
_exports.utils = utils;
_exports.data = data;
//3.0延续，后续废弃
_exports.misc = misc;
_exports.lys = layers;
_exports.components = components;
//新增分类包
_exports.common = common;
_exports.interact = interact;
_exports.render = render;
_exports.model = model;
_exports.biz = business;
_exports.servicev2 = serviceV2;
_exports.service = serviceV3;
/***
 * 定义版本
 */
_exports.version = VERSION;
// 输出全局变量
window.G = _exports;
// module.exports = _exports;